import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('Purchase/GetList', { params });
  },
  getDetail(_, id) {
    return axios.get('Purchase/GetDetail', { params: { id } });
  },
  reject(_, id) {
    return axios.get('Purchase/Reject', { params: { id } });
  },
  approve(_, id) {
    return axios.get('Purchase/Approve', { params: { id } });
  },
};
